import { ILoginDto } from './dtos/login-dto';
import ApiService from '../../utils/base-api/api-service';
import { ILoginResponse } from './dtos/login-response';
import { IResetPassword } from './dtos/reset-password';
import { IForgetPassword } from './dtos/forget-password';
import { IUser } from '../users/dtos/user';
import { UserAuthorizationDataDto } from './dtos/user-authorization-data-dto';

class AuthService extends ApiService {
  constructor() {
    super({
      baseURL: '/',
    });
  }

  isAuthenticated(): Promise<boolean> {
    return this.get<boolean>('/is_authenticated');
  }
  forgetPassword(data: IForgetPassword): Promise<void> {
    return this.post<void, null>('/Login/ForgetPssword', null, {
      params: data,
      skipAuth: true,
      skipErrorNotification: true,
    });
  }

  resetPassword(data: IResetPassword): Promise<void> {
    return this.post<void, null>('/Login/Verify', null, {
      params: data,
      skipAuth: true,
      skipErrorNotification: true,
    });
  }

  login(data: ILoginDto): Promise<ILoginResponse> {
    return this.post<ILoginResponse, ILoginDto>('/Login/LogIn', data, {
      skipAuth: true,
      skipErrorNotification: true,
    });
  }

  logout(): Promise<void> {
    return this.post<void>('/logout');
  }

  signUpAdmin(data: Record<string, unknown>): Promise<unknown> {
    return this.post<unknown, Record<string, unknown>>('/signup-admin', data);
  }
  handleVerify(data: Record<string, unknown>): Promise<IUser> {
    return this.post<IUser, Record<string, unknown>>(
      '/resend-confirm-email',
      data,
    );
  }
  getUserAuthorizationData(): Promise<Array<UserAuthorizationDataDto>> {
    return this.get('/Login/GetUserAuthorizationData');
  }
}

export const authService = new AuthService();
